import { ProdutoMinimal } from '../../modules/lotes/types'

export function formatProdutoLote(
  produto?: ProdutoMinimal,
  naLabel?: string
): string {
  return produto ? produto.nome : `${naLabel || 'Não Informado'}`
}
